import NotistackWrapper from "./presentation/component/NotistackWrapper";
import Router from "./presentation/routes/Router";
import { createTheme, CssBaseline, responsiveFontSizes, ThemeProvider } from "@mui/material";
import '@fontsource/roboto-slab/300.css';
import '@fontsource/roboto-slab/400.css';
import '@fontsource/roboto-slab/500.css';
import '@fontsource/roboto-slab/600.css';
import '@fontsource/roboto-slab/700.css';


const theme = createTheme({
  typography: {
    fontFamily: 'Roboto Slab',
  },
});

function App() {
  
  return (
    <ThemeProvider theme={responsiveFontSizes(theme)}>
      <CssBaseline />
      <NotistackWrapper>
        <Router />
      </NotistackWrapper>
    </ThemeProvider>
  );
}

export default App;
